<template>
  <folders />
</template>

<script>
import Folders from '../components/Folders'
export default {
  name: 'FoldersPage',
  components: {
    Folders
  }
}
</script>